import styled from 'styled-components';

const StyledToolbarHeightDiv = styled.div`
  && {
    ${props => ({ ...props.theme.mixins.toolbar })}
  }
`;

export default StyledToolbarHeightDiv;